/* FreeForm store locator — map, pins, search, modal. Reads the JSON island; no runtime data fetch. */
(function () {
  'use strict';

  var root = document.querySelector('[data-store-locator]');
  if (!root) return;

  var config = window.freeformLocatorConfig || {};
  var dataEl = root.querySelector('[data-locator-data]');
  var mapEl = root.querySelector('[data-locator-map]');
  var listEl = root.querySelector('[data-locator-list]');
  var countEl = root.querySelector('[data-locator-count]');
  var searchEl = root.querySelector('[data-locator-search]');
  var resetEl = root.querySelector('[data-locator-reset]');
  var modalEl = root.querySelector('[data-locator-modal]');
  var modalBody = modalEl.querySelector('.store-locator__modal-body');

  var partners = [];
  try {
    partners = JSON.parse(dataEl.textContent) || [];
  } catch (e) {
    console.error('[store-locator] bad JSON island', e);
  }

  // Only pins with coordinates can be mapped. Featured (cafe) sorts first.
  var located = partners
    .filter(function (p) { return p.lat != null && p.lng != null && p.lat !== '' && p.lng !== ''; })
    .map(function (p) {
      p.lat = parseFloat(p.lat);
      p.lng = parseFloat(p.lng);
      return p;
    })
    .sort(function (a, b) { return (b.featured === true) - (a.featured === true); });

  if (!config.apiKey) {
    mapEl.innerHTML = '<div class="store-locator__error">Map unavailable: add a Google Maps API key in the theme editor.</div>';
    renderList(located, null);
    return;
  }
  if (!located.length) {
    countEl.textContent = 'Locations are being added. Please check back soon.';
  }

  var map, markers = [], infoModalOpen = false, lastFocused = null;

  loadMaps(config.apiKey)
    .then(init)
    .catch(function (err) {
      console.error('[store-locator] Maps failed to load', err);
      mapEl.innerHTML = '<div class="store-locator__error">Map failed to load.</div>';
      renderList(located, null);
    });

  function loadMaps(key) {
    return new Promise(function (resolve, reject) {
      if (window.google && window.google.maps && window.google.maps.importLibrary) return resolve();
      var cb = '__freeformLocatorInit';
      window[cb] = function () { resolve(); };
      var s = document.createElement('script');
      var params = 'key=' + encodeURIComponent(key) + '&libraries=maps,marker,places&loading=async&v=weekly&callback=' + cb;
      s.src = 'https://maps.googleapis.com/maps/api/js?' + params;
      s.async = true;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function init() {
    google.maps.importLibrary('maps').then(function (mapsLib) {
      return google.maps.importLibrary('marker').then(function (markerLib) {
        buildMap(mapsLib.Map);
        buildMarkers(markerLib.AdvancedMarkerElement, markerLib.PinElement);
        renderList(located, null);
        setupSearch();
        fitAll();
      });
    });
  }

  function buildMap(Map) {
    map = new Map(mapEl, {
      center: config.center || { lat: 34.8697, lng: -111.761 },
      zoom: config.zoom || 11,
      mapId: config.mapId || 'DEMO_MAP_ID',
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      clickableIcons: false
    });
  }

  function buildMarkers(AdvancedMarkerElement, PinElement) {
    located.forEach(function (p) {
      var el;
      if (p.featured) {
        el = document.createElement('div');
        el.className = 'store-locator__pin store-locator__pin--featured';
        el.textContent = '★'; // ★
      } else {
        el = new PinElement({
          background: getVar('--sl-pin', '#6F4E37'),
          borderColor: '#ffffff',
          glyphColor: '#ffffff'
        }).element;
      }
      var marker = new AdvancedMarkerElement({
        map: map,
        position: { lat: p.lat, lng: p.lng },
        title: p.name,
        content: el,
        zIndex: p.featured ? 1000 : 1
      });
      marker.addListener('gmp-click', function () { openModal(p); });
      // Fallback for browsers where gmp-click isn't delivered.
      el.addEventListener('click', function () { openModal(p); });
      p._marker = marker;
      markers.push(marker);
    });
  }

  /* ---------- List ---------- */

  function renderList(items, origin) {
    listEl.innerHTML = '';
    if (origin) {
      items = items.slice().sort(function (a, b) {
        return haversine(origin, a) - haversine(origin, b);
      });
    }
    items.forEach(function (p) {
      var li = document.createElement('li');
      li.className = 'store-locator__item' + (p.featured ? ' store-locator__item--featured' : '');

      var name = document.createElement('button');
      name.type = 'button';
      name.className = 'store-locator__item-name';
      name.textContent = p.name;
      name.addEventListener('click', function () { focusPartner(p); });

      var addr = document.createElement('div');
      addr.className = 'store-locator__item-addr';
      addr.textContent = formatAddress(p);

      li.appendChild(name);
      li.appendChild(addr);

      if (origin && isFinite(haversine(origin, p))) {
        var dist = document.createElement('span');
        dist.className = 'store-locator__item-dist';
        dist.textContent = miles(haversine(origin, p)).toFixed(1) + ' mi';
        li.appendChild(dist);
      }
      listEl.appendChild(li);
    });
    if (countEl) {
      countEl.textContent = items.length + (items.length === 1 ? ' location' : ' locations');
    }
  }

  function focusPartner(p) {
    if (map && p._marker) {
      map.panTo({ lat: p.lat, lng: p.lng });
      if (map.getZoom() < 13) map.setZoom(13);
    }
    openModal(p);
  }

  /* ---------- Search ---------- */

  function setupSearch() {
    if (!searchEl) return;
    google.maps.importLibrary('places').then(function (places) {
      var ac = new places.Autocomplete(searchEl, {
        fields: ['geometry'],
        types: ['geocode']
      });
      ac.addListener('place_changed', function () {
        var place = ac.getPlace();
        if (!place.geometry) return;
        var loc = place.geometry.location;
        var origin = { lat: loc.lat(), lng: loc.lng() };
        map.panTo(origin);
        map.setZoom(9);
        renderList(located, origin);
      });
    });
    // Enter without picking a suggestion shouldn't submit a form.
    searchEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });
  }

  if (resetEl) {
    resetEl.addEventListener('click', function () {
      if (searchEl) searchEl.value = '';
      renderList(located, null);
      fitAll();
    });
  }

  function fitAll() {
    if (!map || !located.length) return;
    var bounds = new google.maps.LatLngBounds();
    located.forEach(function (p) { bounds.extend({ lat: p.lat, lng: p.lng }); });
    map.fitBounds(bounds, 48);
  }

  /* ---------- Modal ---------- */

  function openModal(p) {
    modalBody.innerHTML = '';

    if (p.photo) {
      var img = document.createElement('img');
      img.className = 'store-locator__modal-photo';
      img.src = p.photo;
      img.alt = p.name;
      img.loading = 'lazy';
      modalBody.appendChild(img);
    }

    var content = document.createElement('div');
    content.className = 'store-locator__modal-content';

    var h = document.createElement('h3');
    h.className = 'store-locator__modal-name';
    h.id = 'locator-modal-name';
    h.textContent = p.name;
    content.appendChild(h);

    var addressLink = document.createElement('a');
    addressLink.className = 'store-locator__modal-address';
    addressLink.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(formatAddress(p));
    addressLink.target = '_blank';
    addressLink.rel = 'noopener';
    addressLink.textContent = formatAddress(p);
    content.appendChild(addressLink);

    var meta = document.createElement('div');
    meta.className = 'store-locator__modal-meta';
    if (p.phone) {
      var tel = document.createElement('a');
      tel.href = 'tel:' + p.phone.replace(/[^\d+]/g, '');
      tel.textContent = p.phone;
      meta.appendChild(tel);
    }
    if (p.website) {
      var web = document.createElement('a');
      web.href = p.website;
      web.target = '_blank';
      web.rel = 'noopener';
      web.textContent = 'Visit website';
      meta.appendChild(web);
    }
    if (meta.childNodes.length) content.appendChild(meta);

    if (p.description) {
      var desc = document.createElement('p');
      desc.className = 'store-locator__modal-desc';
      desc.textContent = p.description;
      content.appendChild(desc);
    }

    if (p.offerings && p.offerings.length) {
      var chips = document.createElement('ul');
      chips.className = 'store-locator__chips';
      p.offerings.forEach(function (o) {
        var chip = document.createElement('li');
        chip.className = 'store-locator__chip';
        chip.textContent = o;
        chips.appendChild(chip);
      });
      content.appendChild(chips);
    }

    modalBody.appendChild(content);

    lastFocused = document.activeElement;
    modalEl.hidden = false;
    document.body.classList.add('store-locator-modal-open');
    infoModalOpen = true;
    modalEl.querySelector('.store-locator__modal-close').focus();
  }

  function closeModal() {
    modalEl.hidden = true;
    document.body.classList.remove('store-locator-modal-open');
    infoModalOpen = false;
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  modalEl.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-locator-close')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && infoModalOpen) closeModal();
  });

  /* ---------- Helpers ---------- */

  function formatAddress(p) {
    var cityLine = [p.city, p.state].filter(Boolean).join(', ');
    if (p.zip) cityLine += ' ' + p.zip;
    return [p.street, cityLine].filter(Boolean).join(', ');
  }

  function haversine(a, b) {
    var R = 6371000; // metres
    var dLat = rad(b.lat - a.lat);
    var dLng = rad(b.lng - a.lng);
    var lat1 = rad(a.lat), lat2 = rad(b.lat);
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  function rad(d) { return (d * Math.PI) / 180; }
  function miles(m) { return m / 1609.344; }

  function getVar(name, fallback) {
    var v = getComputedStyle(root).getPropertyValue(name).trim();
    return v || fallback;
  }
})();
